import React from 'react';

const NotApplicable = () => (
  <div>

  </div>
);

export default NotApplicable;
